<template>
    <NuxtLoadingIndicator color="#832C41" />

    <NuxtLayout :name="layoutName">
        <NuxtPage :keepalive="shouldKeepAliveProductFilterPage" />
    </NuxtLayout>

    <AddToCartFlyout />
    <AlertModal />
    <StandUpPouchOptionsFlyout theme="" />

    <ChatButton
        v-if="showChatButton"
        id="site-chat-button"
        source="Site Chat Button"
        class="fixed bottom-3 right-3 z-[999999]"
    />
</template>

<script setup lang="ts">
import {
    headlessPageRoutes,
    ppcPageRoutes,
} from '#shared/data/layouts/pageRoutes';
import { storyblokProductFilterRootPaths } from '#shared/data/storyblokProductFilterRootPaths';
import ChatButton from '~/components/ChatButton.vue';
import AddToCartFlyout from '~/components/cart/AddToCartFlyout.vue';
import StandUpPouchOptionsFlyout from '~/components/page-building/pick-your-product/StandUpPouchOptionsFlyout.vue';

const route = useRoute();
const { convertEnabled, convertEnvironment, convertSdkKey, liveChatEnabled } =
    useRuntimeConfig().public;

const normalizePath = (path: string) =>
    path !== '/' && path.endsWith('/') ? path.slice(0, -1) : path;

const shouldKeepAliveProductFilterPage = computed(() => {
    const normalizedPath = normalizePath(route.path);

    return storyblokProductFilterRootPaths.some((rootPath) => {
        return (
            normalizedPath === rootPath ||
            normalizedPath.startsWith(`${rootPath}/`)
        );
    });
});

const scripts = [];

if (convertEnabled) {
    scripts.push({
        src: `//cdn-4.convertexperiments.com/v1/js/${convertSdkKey}.js?environment=${convertEnvironment}`,
    });
}

if (liveChatEnabled) {
    scripts.push({ src: '/js/zopim.js', async: true });
}

useHead({
    script: scripts,
});

const layoutName = computed(() => {
    if (ppcPageRoutes.includes(route.path)) {
        return 'ppc';
    }

    if (
        headlessPageRoutes.includes(route.path) ||
        /^\/quotes\/\d+$/.test(route.path)
    ) {
        return 'headless';
    }

    return undefined;
});

const showChatButton = computed(() => route.path !== '/roastar-design-lab');

onMounted(() => {
    useHead(() => ({
        bodyAttrs: {
            class: 'nuxt-loaded',
        },
    }));
});
</script>
